import React from "react";
import styles from "./styles.module.scss";

export default () => {
    return (
        <div className={styles.contactUs}>
            <div className={styles.content}>
                <div>
                    <span>
                        Gain market sentiment insights and trading transparency
                        with an S&P Global dataset covering more than $25 trillion{" "}
                        <br />
                        of global securities from 20,000 institutional funds,
                        ten years of history and over three million intraday{" "}
                        <br />
                        transactions.
                    </span>
                </div>
                <div className={styles.link}>
                    <a
                        target={"_blank"}
                        rel="noopener noreferrer"
                        href="https://cdn.ihsmarkit.com/www/pdf/0220/3470-JL-0119-0220-CW-FIN-Factsheet-SecuritiesFinanceOverview-update4-HighRes.pdf"
                    >
                        S&P Global Securities Finance overview
                    </a>
                </div>
                <div>
                    <span>Mail : ops@kslnetwork.com</span>
                </div>
            </div>
        </div>
    );
};
